<template>
  <div id="warranty_list">
    <van-nav-bar
      title="报修单(工人)"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <van-dropdown-menu>
      <van-dropdown-item v-model="checkStatus" :options="statusOptions" @change="changeStatus" />
      <van-dropdown-item v-model="value2" :options="option2" @change="changeSort" />
    </van-dropdown-menu>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div v-for="(item, index) in list" :key="index" class="list-item" @click="showReport(item.id, item)">
        <div class="item-left">
          <img :src="item.file_url_thumb" class="item-left-image" />
        </div>
        <div class="item-right">
          <div class="item-right-header">
            <div class="item-right-type">{{ item.ma_type_cn }}</div>
            <div class="item-right-status" v-if="item.status_value">{{ item.status_value }}</div>
          </div>
          <div class="item-right-time">品   牌 : {{ item.brand_en }}</div>
          <div class="item-right-time">维修项目 : {{ item.ma_item_cate_cn }}</div>
          <div class="item-right-time">维修时间 : {{ item.ma_start_to_end }}</div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import {getOrderList, getOrderStatusList} from '../../api/order'

const STATUS = ['', '待接受', '已提交', '待维修', '已完工', '待验收', '验收通过', '待返工']

export default {
  name: 'warranty_list',
  data () {
    return {
      value2: '',
      active: 0,
      list: [],
      tabTypes: ['全部', '待审批', '待维修', '已拒绝'],
      loading: false,
      finished: false,
      refreshing: false,
      error: false,
      page: 0,
      categories: [],
      status: '',
      statusOptions: [],
      option2: [
        { text: '默认排序', value: '' },
        { text: '创建时间降序', value: 'desc' },
        { text: '创建时间升序', value: 'asc' }
      ],
      checkStatus: ''
    }
  },
  created () {
    if (typeof this.$route.query.status !== 'undefined') {
      this.checkStatus = this.$route.query.status
    }
    this.getOptions()
  },
  methods: {
    async getOptions() {
      await getOrderStatusList().then((res) => {
        if (res.data.data) {
          this.statusOptions = []
          for (const i in res.data.data) {
            this.statusOptions.push({
              text: res.data.data[i].v,
              value: res.data.data[i].k
            })
          }
        }
      })
    },
    async initList (page, status = '', sort = '') {
      let queryData = {page: page, is_leader: 0}
      if (status !== '' && typeof status !== 'undefined') {
        queryData.status = status
      } else if (this.$route.query && this.$route.query.status) {
        this.list = []
        queryData.status = this.$route.query.status
      }
      if (queryData.status === 'all') {
        queryData.status = ''
      }
      if (sort !== '') {
        queryData.sort = sort
      }
      if (this.finished === true) {
        return false
      }
      await getOrderList(queryData).then((res) => {
        console.log('res........', res.data.data)
        if (res.data.data.list.length < 20) {
          this.finished = true
        }
        if (res.data.data.list) {
          this.list.push(...res.data.data.list)
        } else {
          this.finished = true
          this.list = []
        }
      })
    },
    onLoad () {
      setTimeout(() => {
        if (this.finished) {
          return false
        }
        if (this.refreshing) {
          this.list = []
          this.refreshing = false
        }
        this.initList(this.page + 1)
        this.loading = false
      }, 1000)
    },
    onRefresh () {
      if (this.finished) {
        return false
      }
      // 清空列表数据
      this.finished = false

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.onLoad()
    },
    onClickLeft () {
      this.$router.push({path: '/index'})
    },
    showReport (id, val) {
      console.log('val........', val)
      this.$router.push({path:'/warranty_detail', query: {id: id, annex_id: val.annex_id, ma_item_id: val.ma_item_id, order_worker_id: val.order_worker_id, appo_task_id: val.appo_task_id}})
    },
    changeTypes (index) {
      this.active = index
      let status = ''
      if (index === 0) {
        status = ''
      } else if (index === 1) {
        status = 0
      } else if (index === 2) {
        status = 1
      } else if (index === 3) {
        status = 2
      }
      // 0已提交、1审批通过、2拒绝、3保存
      this.initList(1, status)
      this.list = []
    },
    changeStatus (val) {
      this.checkStatus = val
      this.list = []
      this.finished = false
      this.initList(1, val, this.value2)
    },
    changeSort (val) {
      this.value2 = val
      this.list = []
      this.finished = false
      this.initList(1, this.checkStatus, val)
    }
  }
}
</script>

<style>
.van-card__content {
  text-align: left;
}
.van-dropdown-menu__bar {
  width: 60% !important;
  padding-right: 40% !important;
}
.list-item {
  height: 90px;
  overflow: hidden;
  margin-bottom: 10px;
  padding: 10px;
  background: #ffffff;
}
.list-show {
  background: #F5F5F5;
  min-height: calc(100vh - 100px);
}
.item-left, .item-right {
  float: left;
}
.item-left {
  width: 90px;
}
.item-right-status {
  font-size: 12px;
  height: 20px;
  line-height: 20px;
  width: auto;
  padding: 0 8px;
  margin-right: 8px;
  text-align: center;
  border-radius: 16px;
  background: #fcf4eb;
  color: #de883d;
}
.item-right {
  width: calc(90% - 70px);
  font-size: 14px;
  margin-left: 10px;
  text-align: left;
}
.item-right-type {
  color: #000000;
  margin-right: 10px;
}
.item-right-status, .item-right-type {
  float: left;
}
.item-right-header {
  overflow: hidden;
}
.item-left-image {
  max-width: 90px;
  max-height: 90px;
  border-radius: 4px;
  object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// src/views/order/worker_warranty_list.vue